import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Languagebar from './Languagebar';

const LOCALES = [
  { localeId: 'ar_AE', language: 'Arabic', country: 'United Arab Emirates' },
  { localeId: 'de_DE', language: 'German', country: 'Germany' },
  { localeId: 'en_US', language: 'English', country: 'United States', default: true },
  { localeId: 'es_ES', language: 'Spanish', country: 'Spain' },
  { localeId: 'no_NB', language: 'Norwegian', country: 'Norway' },
  { localeId: 'pt_PT', language: 'Portuguese', country: 'Portugal' },
];

export default class LanguagebarExample extends Component {

  state = {
    locales: LOCALES,
    selected: LOCALES[2].localeId,
    visible: [LOCALES[2], LOCALES[0]],
  };

  onAdd = e => {
    window.showAppInfo(`Add ${e.target.value.language}`);
    this.setState({
      selected: e.target.value.localeId,
      visible: this.state.visible.concat(e.target.value),
    });
  };

  onChange = e => {
    window.showAppInfo(e.target.value.language);
    this.setState({ selected: e.target.value.localeId });
  };

  onChangeProps = e => {
    this.setState(e.target.value);
  };

  onRemove = (e, index, selected) => {
    const visible = this.state.visible.slice();

    window.showAppInfo(`Remove ${e.target.value.language}`);
    visible.splice(index, 1);
    this.setState({ visible, selected });
  };

  render() {
    return (
      <Example {...this.props}>
        <Properties onChange={this.onChangeProps} defaultProps={Languagebar.defaultProps} propTypes={Languagebar.propTypes} propValues={this.state}/>
        <Languagebar {...this.state} onChange={this.onChange} onAdd={this.onAdd} onRemove={this.onRemove}/>
        <SourceCode querySelector=".core-languagebar"/>
      </Example>
    );
  }

}
